import { render } from "./ShareDesktop.vue?vue&type=template&id=f8c10a92&scoped=true&ts=true"
import script from "./ShareDesktop.vue?vue&type=script&lang=ts"
export * from "./ShareDesktop.vue?vue&type=script&lang=ts"

import "./ShareDesktop.vue?vue&type=style&index=0&id=f8c10a92&scoped=true&lang=scss"
import "./ShareDesktop.vue?vue&type=style&index=1&id=f8c10a92&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c10a92"]])

export default __exports__